//import { DndProvider } from 'react-dnd';
//import { HTML5Backend } from 'react-dnd-html5-backend';
import React, { useRef, useState, useCallback } from 'react';
import { Label } from '@teo/components';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { TargetBox } from './TargetBox';
import { useTranslation } from 'react-i18next';
import UploadedPhoto from '@/components/UploadDropzoneSection/UploadedPhoto';
import FileContainer from './FileContainer';
import { uploadImage, uploadFile } from '@/query/documents';
import { LibraryModal } from '../LibraryModal/LibraryModal';

const UploadDropzoneSection = ({
  setUploadLogo,
  uploadLogo,
  courseImg,
  onBlur,
  bannerLPImg,
  onlyFile,
  replaceBtn,
}: any) => {
  const [photoInfo, setPhotoInfo] = useState();
  const { t } = useTranslation();
  const fileInputRef = useRef<HTMLInputElement>(null);
  const [droppedFiles, setDroppedFiles] = useState<File[]>([]);
  const [isOpenLibraryModal, setIsOpenLibraryModal] = useState(false);

  const handleFileDrop = useCallback(
    async (item: { files: any }) => {
      if (item) {
        const files = item.files;
        setDroppedFiles(files);
        const size = courseImg || bannerLPImg ? 900 : 100;
        const data = item.files[0]?.type.includes('pdf')
          ? await uploadFile('upload/', item.files[0])
          : await uploadImage(item.files[0], size, size);
        setUploadLogo(data);
      }
    },
    [setDroppedFiles, setUploadLogo]
  );

  const handleUploadPhoto = async (event: any): Promise<any> => {
    const img = event.target.files[0];
    setPhotoInfo(img);
    const size = courseImg || bannerLPImg ? 900 : 100;
    const data = img?.type.includes('pdf')
      ? await uploadFile('upload/', img)
      : await uploadImage(img, size, size);
    setUploadLogo(data);
  };

  const handleUploadPhotoLibrary = async (image: any): Promise<any> => {
    const res = await fetch(image);
    const blob = await res.blob();
    const mime = blob.type;
    const ext = mime.slice(mime.lastIndexOf('/') + 1, mime.length);
    const img: any = new File([blob], `${blob.size}.${ext}`, {
      type: mime,
    });
    setPhotoInfo(img);
    const size = courseImg || bannerLPImg ? 900 : 100;
    const data = await uploadImage(img, size, size);
    setUploadLogo(data);
  };

  const handleUseImageLibrary = async (imageUrl: any) => {
    setUploadLogo(imageUrl);
  };

  return (
    <>
      <div>
        <div id="uploadDropzone" className="mt-3">
          <DndProvider backend={HTML5Backend}>
            {!photoInfo && droppedFiles.length === 0 && !uploadLogo && (
              <TargetBox
                onDrop={handleFileDrop}
                fileInputRef={fileInputRef}
                handleUploadPhoto={handleUploadPhoto}
                courseImg={courseImg}
                bannerLPImg={bannerLPImg}
                setIsOpenLibraryModal={setIsOpenLibraryModal}
                onlyFile={onlyFile}
                replaceBtn={replaceBtn}
              />
            )}
            {droppedFiles.length > 0 && !photoInfo && (
              <FileContainer
                files={droppedFiles}
                fileInputRef={fileInputRef}
                handleUploadPhoto={handleUploadPhoto}
                courseImg={courseImg}
                bannerLPImg={bannerLPImg}
                onlyFile={onlyFile}
                replaceBtn={replaceBtn}
              />
            )}
            {(photoInfo || uploadLogo) && (
              <UploadedPhoto
                photoInfo={photoInfo}
                fileInputRef={fileInputRef}
                handleUploadPhoto={handleUploadPhoto}
                uploadLogo={uploadLogo}
                courseImg={courseImg}
                bannerLPImg={bannerLPImg}
                setIsOpenLibraryModal={setIsOpenLibraryModal}
                onlyFile={onlyFile}
                replaceBtn={replaceBtn}
              />
            )}
          </DndProvider>
        </div>
      </div>
      {isOpenLibraryModal && (
        <LibraryModal
          setIsOpenLibraryModal={setIsOpenLibraryModal}
          isOpenLibraryModal={isOpenLibraryModal}
          lessonPage={false}
          setUploadFile={handleUploadPhotoLibrary}
          onSelectImage={handleUseImageLibrary}
        />
      )}
    </>
  );
};

export default UploadDropzoneSection;
